












import { defineComponent } from "@vue/composition-api";
import {
  CreatorServiceMessageDetails,
  isCreatorServiceMessageDetails,
} from "@scrile/api-provider/dist/api/CreatorServicesProvider";
import { Message } from "@scrile/api-provider/dist/projects/scrileConnect/MessagesProvider";
import FormatMoney from "@/components/FormatMoney";

export default defineComponent({
  name: "MessagePreviewServicePurchase",
  components: { FormatMoney },
  props: {
    message: { type: Object as () => Message, required: true },
    isOpponentMessage: { type: Boolean, required: true },
  },
  computed: {
    details(): CreatorServiceMessageDetails | null {
      return isCreatorServiceMessageDetails(this.message.details) ? this.message.details : null;
    },
  },
});
